// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27QKv","field":"styles_field__9biQP","fieldCol":"styles_fieldCol__sIacp","diffCol":"styles_diffCol__yGHVf","diff":"styles_diff__3tWSq"};